import { IconType } from '../../core-data-model';

/**
 * CSS class used by many icons
 */
const iconSvgClass = 'icon-svg';

/**
 * Available customizations that can be added to an icon type in the mapping below
 */
export type IconCustomizations = {
    classSelector?: string;
    style?: any;
    stroke?: string;
    useFontSize?: boolean;
};

/**
 * Because icons are now dynamically rendered we needed a way to map the previous
 * customizations to their Icon types, since they are no longer statically set in the template.
 * This mapping allows us to access the customizations for individual Icon Types.
 */
export const StaticIconCustomizations = new Map<
    IconType | string,
    IconCustomizations
>([
    [IconType.Add, { classSelector: iconSvgClass }],
    [IconType.SendEmailGroup, { classSelector: iconSvgClass }],
    [IconType.PersonSimple, { classSelector: iconSvgClass }],
    [IconType.Copy, { classSelector: iconSvgClass }],
    [IconType.ListToDo, { classSelector: iconSvgClass }],
    [IconType.MessageTyping, { classSelector: iconSvgClass }],
    [IconType.PerformanceIncrease, { classSelector: iconSvgClass }],
    [IconType.Currency, { classSelector: iconSvgClass }],
    [IconType.TeamMeeting, { classSelector: iconSvgClass }],
    [IconType.Trash, { classSelector: iconSvgClass }],
    [IconType.SessionDelete, { classSelector: iconSvgClass }],
    [IconType.SessionEdit, { classSelector: iconSvgClass }],
    [IconType.ClosePeek, { classSelector: iconSvgClass, useFontSize: true }],
    [
        IconType.ActionEllipsis,
        { classSelector: iconSvgClass, useFontSize: true }
    ],
    [IconType.StreamlineBriefcase, { classSelector: iconSvgClass }],
    [IconType.StreamlinePerson, { classSelector: iconSvgClass }],
    [IconType.StreamlineFullStar, { classSelector: iconSvgClass }],
    [IconType.StreamlineHalfStar, { classSelector: iconSvgClass }],
    [IconType.StreamlineEmptyStar, { classSelector: iconSvgClass }],
    [IconType.Learn, { classSelector: iconSvgClass }],
    [
        IconType.PersonTearDrop,
        { classSelector: iconSvgClass, useFontSize: true }
    ],
    [IconType.Edit, { classSelector: iconSvgClass, useFontSize: true }],
    [
        IconType.CheckMarkCircle,
        { classSelector: iconSvgClass, useFontSize: true }
    ],
    [IconType.ChevronDown, { classSelector: iconSvgClass, useFontSize: true }],
    [IconType.Delete, { classSelector: iconSvgClass }],
    [IconType.BentArrow, { classSelector: iconSvgClass }],
    [IconType.TeamDetails, { classSelector: iconSvgClass }],
    [IconType.FilledDownArrow, { classSelector: iconSvgClass }],
    [IconType.HeadQuestionMark, { classSelector: iconSvgClass }],
    [IconType.ThumbUp, { classSelector: iconSvgClass }],
    [IconType.ThumbDown, { classSelector: iconSvgClass }],
    [IconType.FeedbackReceived, { classSelector: iconSvgClass }],
    [IconType.MultiColorCircleCheckMark, { classSelector: iconSvgClass }],
    [IconType.SendEmail, { stroke: 'white' }],
    [IconType.PiLogoRedWithName, { classSelector: 'pi-logo-red-with-name' }],
    [
        IconType.PiLogoWhiteWithName,
        { style: { width: '101px', height: '42px' } }
    ],
    [
        IconType.PiLogoBlackWithName,
        { style: { width: '101px', height: '42px' } }
    ]
]);
